import { forwardRef } from 'react';

import { BsStars } from 'react-icons/bs';

import { Text, UnstyledButton } from '@highlight-cp/core-ui';

import classes from './prompt-pill.module.css';

export interface PromptPillProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  tabIndex?: number;
  onFocus?: () => void;
}

/**
 * Single-line pill control for AI chat prompt suggestions.
 * Complements `PromptButton` (card layout) with inline icon + label styling.
 */
const PromptPill = forwardRef<HTMLButtonElement, PromptPillProps>(
  ({ label, onClick, disabled = false, tabIndex, onFocus }, ref) => (
    <UnstyledButton
      ref={ref}
      type="button"
      className={classes.pill}
      onClick={onClick}
      onFocus={onFocus}
      disabled={disabled}
      tabIndex={tabIndex}
    >
      <BsStars size={16} className={classes.icon} aria-hidden />
      <Text size="sm" component="span">
        {label}
      </Text>
    </UnstyledButton>
  ),
);

PromptPill.displayName = 'PromptPill';

export default PromptPill;
